import { render, staticRenderFns } from "./Texts.vue?vue&type=template&id=6f6014b9&scoped=true"
import script from "./Texts.vue?vue&type=script&lang=js"
export * from "./Texts.vue?vue&type=script&lang=js"
import style0 from "./Texts.vue?vue&type=style&index=0&id=6f6014b9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d4iazq3oduqb2szvpffvlcs4f4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6014b9",
  null
  
)

export default component.exports